import { Loader } from '@googlemaps/js-api-loader';
import { useEffect, useState } from 'react';

const apiKey = process.env.NX_GOOGLE_MAPS_API_KEY;
const loader = new Loader({
  apiKey: apiKey as string,
  version: 'weekly',
  libraries: ['places'],
});
export const useGoogleAutocomplete = ():
  | google.maps.places.AutocompleteService
  | undefined => {
  const [service, setService] = useState<
    google.maps.places.AutocompleteService | undefined
  >(undefined);

  useEffect(() => {
    (async () => {
      if (typeof window === 'undefined' || !loader) {
        return;
      }
      await loader.importLibrary('places');

      setService(new google.maps.places.AutocompleteService());
    })();
  }, [setService]);

  return service;
};

export const useGooglePlace = ():
  | google.maps.places.PlacesService
  | undefined => {
  const [service, setService] = useState<
    google.maps.places.PlacesService | undefined
  >(undefined);

  useEffect(() => {
    (async () => {
      if (typeof window === 'undefined' || !loader) {
        return;
      }
      await loader.importLibrary('places');

      setService(
        new google.maps.places.PlacesService(document.createElement('div')),
      );
    })();
  }, [setService]);

  return service;
};
